import React, { useState, useEffect, useRef, useCallback, use } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { toast, Flip } from 'react-toastify';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import {
    setSelectedSubtitle,
    addSubtitle,
    deleteSubtitle,
    updateSubtitle,
    setChangedSubtitle
} from '@modules/subtitle';

import api from '@utils/axiosInstance';
import { milliSecondsToFormattedTime } from '@utils/milliSecondsToFormattedTime';
import {
    handleTimeInputChange,
    saveSubtitlesToServer as saveSubtitles
} from '@utils/timeUtils';
import TextInput from './TextInput';
const ACTIVE_REGION_COLOR = "rgba(0, 123, 255, 0.2)";

function SubList({ idx, item, videoDurationTime }) {
    const dispatch = useDispatch();
    const { uuid, lang } = useParams();

    const playTime = useSelector(state => state.media.playTime);
    const subtitleList = useSelector(state => state.subtitle.subtitleList);
    const changedTimelineSubtitle = useSelector(state => state.subtitle.changedTimelineSubtitle);
    const organizationData = useSelector(state => state.organization.organizationData);
    const userToken = useSelector(state => state.organization.userToken);

    const [isSelected, setIsSelected] = useState(false);
    const [colors, setColors] = useState('black');
    const [changingSubtitle, setChangingSubtitle] = useState({ ...item });
    const [isChanged, setIsChanged] = useState(false);

    const startTimeRef = useRef(null);
    const endTimeRef = useRef(null);
    const contentRef = useRef(null);

    // 현재 재생 시간이 자막 시간 범위 내에 있는지 확인
    useEffect(() => {
        if (playTime && item) {
            setIsSelected(item.start <= playTime && item.end >= playTime);
        }
    }, [playTime, item]);

    useEffect(() => {
        if (changedTimelineSubtitle && item.id === changedTimelineSubtitle.id) {
            console.log('eeeeesdsd', changedTimelineSubtitle);
            setChangingSubtitle(changedTimelineSubtitle);
            if (startTimeRef.current) {
                startTimeRef.current.textContent = milliSecondsToFormattedTime(changedTimelineSubtitle.start);
            }
            if (endTimeRef.current) {
                endTimeRef.current.textContent = milliSecondsToFormattedTime(changedTimelineSubtitle.end);
            }
        }
    }, [changedTimelineSubtitle, item]);

    // 초기 값 설정
    useEffect(() => {
        if (item) {
            updateTimeValues();
            if (contentRef.current) {
                contentRef.current.textContent = item.content || "";
            }
            setChangingSubtitle({ ...item });
            setColors('black');
        }
    }, [item]);

    // 시간 값 업데이트 함수
    const updateTimeValues = useCallback(() => {
        if (startTimeRef.current) {
            startTimeRef.current.textContent = milliSecondsToFormattedTime(item.start);
        }
        if (endTimeRef.current) {
            endTimeRef.current.textContent = milliSecondsToFormattedTime(item.end);
        }

        setChangingSubtitle({ ...item });
    }, [item]);

    // 내용 변경 처리
    // const handleContentChange = (text) => {
    //     console.log('content', text);
    //     setChangingSubtitle(prev => ({
    //         ...prev,
    //         content: text
    //     }));
    // };

    // 시작 시간 변경 처리
    const handleStartTimeChange = useCallback((e) => {
        setIsChanged(true);

        const parsedSeconds = handleTimeInputChange(e, {
            setColors,
            setChangingItem: setChangingSubtitle,
            item,
            timeField: 'start'
        });

        if (parsedSeconds !== null) {
            dispatch(setChangedSubtitle({
                ...subtitleList[idx],
                idx: idx,
                start: parsedSeconds,
                type: 'start'
            }));
        }
    }, [item, subtitleList, idx, dispatch]);

    // 종료 시간 변경 처리
    const handleEndTimeChange = useCallback((e) => {
        setIsChanged(true);
        const parsedSeconds = handleTimeInputChange(e, {
            setColors,
            setChangingItem: setChangingSubtitle,
            item,
            timeField: 'end'
        });

        if (parsedSeconds !== null) {
            dispatch(setChangedSubtitle({
                ...subtitleList[idx],
                idx: idx,
                end: parsedSeconds,
                type: 'end'
            }));
        }
    }, [item, subtitleList, idx, dispatch]);

    // 변경사항 저장
    const saveChanges = useCallback((type) => {
        setColors('black');
        setIsChanged(false);

        console.log('changingSubtitle', changingSubtitle);
        // 유효성 검사
        if (changingSubtitle.start >= changingSubtitle.end) {
            toast.error("시작 시간은 종료 시간보다 빨라야 합니다", {
                position: "top-center",
                transition: Flip
            });
            updateTimeValues();
            return;
        }

        // 이전 자막과 겹치는지 확인
        if (idx > 0 && changingSubtitle.start < subtitleList[idx - 1].end) {
            toast.error("이전 자막의 종료 시간보다 빨라질 수 없습니다", {
                position: "top-center",
                transition: Flip
            });
            updateTimeValues();
            return;
        }

        // 다음 자막과 겹치는지 확인
        if (idx < subtitleList.length - 1 && changingSubtitle.end > subtitleList[idx + 1].start) {
            toast.error("시작 시간은 종료 시간보다 빨라야 합니다", {
                position: "top-center",
                transition: Flip
            });
            updateTimeValues();
            return;
        }
        // 자막이 비어있지 않은지 확인
        let newStart = type === 'start' ? changingSubtitle.start : subtitleList[idx].start;
        let newEnd = type === 'end' ? changingSubtitle.end : subtitleList[idx].end;

        console.log('eee', newStart, newEnd)
        const newSubtitle = { ...changingSubtitle, start: newStart, end: newEnd };
        const updatedList = [...subtitleList];
        updatedList[idx] = newSubtitle;
        console.log('updatedList', updatedList, changingSubtitle);
        saveSubtitlesToServer(updatedList);
        dispatch(updateSubtitle(idx, { start: newStart, end: newEnd }));
    }, [changingSubtitle, idx, subtitleList, updateTimeValues]);

    const addSubtitleBlock = useCallback(() => {
        const arr = subtitleList.map(el => Number(el.id));
        const maxId = Math.max(...arr, 0); // 빈 배열일 경우 대비
        const DEFAULT_DURATION = 1;
        const MIN_DURATION = 0.1;
        const SAFETY_MARGIN = 0.05;

        let newSubtitle;

        if (idx === subtitleList.length - 1) {
            // 마지막 자막 뒤에 추가
            const newStart = Math.min(item.end + SAFETY_MARGIN, videoDurationTime - MIN_DURATION);
            const newEnd = Math.min(newStart + DEFAULT_DURATION, videoDurationTime);

            newSubtitle = {
                id: maxId + 1,
                start: newStart,
                end: newEnd,
                content: ""
            };
        } else {
            // 중간 삽입
            const prevEnd = item.end;
            const nextStart = subtitleList[idx + 1].start;

            const availableStart = prevEnd + SAFETY_MARGIN;
            const availableEnd = nextStart - SAFETY_MARGIN;

            const availableDuration = availableEnd - availableStart;

            if (availableDuration >= MIN_DURATION) {
                const actualDuration = Math.min(DEFAULT_DURATION, availableDuration);

                newSubtitle = {
                    id: maxId + 1,
                    start: availableStart,
                    end: availableStart + actualDuration,
                    content: ""
                };
            } else {
                toast.warn("⚠️ 자막 사이 여유가 너무 좁아 삽입할 수 없습니다.", {
                    position: "top-center",
                    transition: Flip
                });
                return; // 삽입 중단
            }
        }

        // Redux 상태 업데이트
        dispatch(addSubtitle(idx, newSubtitle));

        // 서버 반영
        const newSubtitles = [
            ...subtitleList.slice(0, idx + 1),
            newSubtitle,
            ...subtitleList.slice(idx + 1)
        ];

        saveSubtitlesToServer(newSubtitles);
    }, [idx, item, subtitleList, videoDurationTime, dispatch]);
    // 자막 삭제
    const deleteSubtitleBlock = useCallback(() => {
        dispatch(deleteSubtitle(idx));

        let newSubtitleList = [...subtitleList];

        if (newSubtitleList.length <= 1) {
            const arr = newSubtitleList.map(el => Number(el.id));
            const maxId = Math.max(...arr);
            newSubtitleList = [{
                id: maxId + 1,
                start: 0,
                end: 1,
                content: ""
            }];
        } else {
            newSubtitleList.splice(idx, 1);
        }

        saveSubtitlesToServer(newSubtitleList);
    }, [idx, subtitleList, dispatch]);

    // 서버에 자막 저장
    const saveSubtitlesToServer = useCallback((subtitles) => {
        return saveSubtitles(subtitles, {
            api,
            userToken,
            uuid,
            orgCode: organizationData.organization_code,
            lang
        });
    }, [userToken, uuid, organizationData, lang]);

    // 자막 선택
    const handleSubListClick = useCallback(() => {
        // dispatch(setSelectedSubtitle(item));
    }, [dispatch, item]);


    return (
        <div
            className={`subList ${isSelected ? 'active' : 'inactive'} ${isChanged ? 'changed' : ''}`}
            onClick={handleSubListClick}
        >
            <div className="col-text-subtitle">
                {/* <div
                    ref={contentRef}
                    className="editable-text"
                    contentEditable="true"
                    onInput={(e) => handleContentChange(e.target.textContent)}
                    onBlur={() => saveChanges('content')}
                    suppressContentEditableWarning={true}
                /> */}
                <TextInput
                    idx={idx}
                    text={item.content}
                    el={item}
                    setIsChanged={setIsChanged}
                />
            </div>

            <div className="btns-subtitle">
                {
                    subtitleList.length > 1 && (
                        <Box className="btn-del" onClick={deleteSubtitleBlock}>
                            <DeleteOutlineIcon fontSize="small" color="action" />
                        </Box>
                    )
                }
                <Box className="btn-add-subtitle" onClick={addSubtitleBlock}>
                    <AddCircleOutlineIcon />
                </Box>
            </div>

            <div className="col-time-subtitle">
                <div className="time-inputs">
                    <div
                        ref={startTimeRef}
                        className="editable-time"
                        contentEditable="true"
                        onInput={handleStartTimeChange}
                        onBlur={() => saveChanges('start')}
                        suppressContentEditableWarning={true}
                        style={{ color: colors }}
                    />
                    <div
                        ref={endTimeRef}
                        className="editable-time"
                        contentEditable="true"
                        onInput={handleEndTimeChange}
                        onBlur={() => saveChanges('end')}
                        suppressContentEditableWarning={true}
                        style={{ color: colors }}
                    />
                </div>
            </div>
        </div>
    );
}

export default SubList;